import { useTranslation } from 'react-i18next';
import { SPINS_PER_DAY } from '@/modules/promotions/helpers/fortuneWheel';
import { useFortuneWheel } from '@/modules/promotions/hooks/useFortuneWheel';
import { useGetCommonStore } from '@/store';
import { ScSpinsCounter } from './styled';

export const SpinsCounter = () => {
  const { t } = useTranslation('wheel');
  const useCommonStore = useGetCommonStore();
  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const { spinsLeftAmount } = useFortuneWheel();

  return isAuthenticated ? (
    <ScSpinsCounter>
      <span>
        {t('spinsCount')}: {spinsLeftAmount}/{SPINS_PER_DAY}
      </span>
    </ScSpinsCounter>
  ) : null;
};
